// src/components/pages/Sitemap.jsx (optional)
import {
  Box,
  Container,
  Heading,
  Stack,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

export default function Sitemap() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          Sitemap
        </Heading>
        <Stack spacing={2}>
          <ChakraLink as={RouterLink} to="/">
            Home
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/tax-relief-companies">
            Companies
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/tax-relief-blog">
            Blog
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/tax-relief-calculator">
            Calculator
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/how-we-review">
            How We Review
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/data-sources">
            Data & Sources
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/about-us">
            About Us
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/privacy-policy">
            Privacy Policy
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/terms-of-use">
            Terms of Use
          </ChakraLink>
          <ChakraLink as={RouterLink} to="/advertiser-disclosure">
            Advertiser Disclosure
          </ChakraLink>
        </Stack>
      </Container>
    </Box>
  );
}
